<template>
	<LayoutFormInputGeneral :inputId="inputId" :title="title" :subtitle="subtitle">
		<div class="vstack gap-3">
			<div class="hstack gap-3" v-for="(level, index) in levels" v-bind:key="index">
				<div class="flex-fill w-75">
					<input type="text"
						v-model="level.name"
						class="form-control form-control-sm"
						placeholder="Nombre del nivel">
				</div>
				<div class="flex-fill">
					<div class="input-group input-group-sm">
						<span class="input-group-text">%</span>
						<VueNumberFormat
							v-model:value="level.commission"
							class="form-control"
							placeholder="Comisión alcanzada"
							:options="{ precision: 2, acceptNegative: false }"
						></VueNumberFormat>
					</div>
				</div>
				<div>
					<button type="button" class="btn btn-sm btn-square btn-neutral" @click="remove(index)"><i class="bi bi-trash"></i></button>
				</div>
			</div>
			<a href="javascript:void(0);" class="link-primary" @click="add"><i class="bi bi-plus pe-1"></i>Agregar nivel</a>
		</div>
	</LayoutFormInputGeneral>
</template>

<script>
	import { computed } from 'vue';
	import _ from 'lodash';

	export default {
		props: {
			levels: Array,
			title: String,
			subtitle: String,
			placeholder: String
		},
		setup(props, { emit }) {
			const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;

			const add = () => {
				props.levels.push({
					name: null,
					commission: null
				});
			}

			const remove = (index) => {
				_.pullAt(props.levels, index);
			}

			return { inputId, add, remove };
		}
	}
</script>